import { render, staticRenderFns } from "./BackendSwitcher.vue?vue&type=template&id=23dc20a4&scoped=true&"
import script from "./BackendSwitcher.vue?vue&type=script&lang=js&"
export * from "./BackendSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./BackendSwitcher.vue?vue&type=style&index=0&id=23dc20a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc20a4",
  null
  
)

export default component.exports